import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { PermissionSetType, UserType } from 'api/models';
import { useUserPermissionSetType } from 'hooks/permissions';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { usePartnerCompanyPermission } from 'hooks/use-partner';
import { useUser } from 'hooks/use-user';
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { NotFoundPage, TimesheetFeatureDiscoveryPage, TimesheetsRoutes } from 'routes/vendor/lazy-imports';
// import { retryImportInsideRoutesDefinition } from 'utils/lazyWithRetry';
const TimesheetsRoutesLayout = ({ children })=>{
    const { user } = useUser();
    const [isTimesheetFeatureEnabled] = useAccountFeature(AccountFeature.Timesheets);
    const currentUserPermissionSetType = useUserPermissionSetType();
    const isAccountAdmin = currentUserPermissionSetType === PermissionSetType.AccountAdmin;
    const { canPartnerTrackTime } = usePartnerCompanyPermission();
    if (isTimesheetFeatureEnabled && (user.userType === UserType.Native || canPartnerTrackTime)) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    if (isAccountAdmin) {
        return /*#__PURE__*/ _jsx(TimesheetFeatureDiscoveryPage, {});
    }
    return /*#__PURE__*/ _jsx(NotFoundPage, {});
};
export const timesheetRoutes = {
    path: `${ROUTE_PATHS.TIMESHEETS}/*`,
    element: /*#__PURE__*/ _jsx(SecureRoute, {
        rule: "TIMESHEET:READ",
        children: /*#__PURE__*/ _jsx(TimesheetsRoutesLayout, {
            children: /*#__PURE__*/ _jsx(TimesheetsRoutes, {})
        })
    })
};
